<template>
  <div class="about">
    Order number: {{ audit.order_no }}<br />
    Date: {{ audit.date }}<br />
    Reason: {{ audit.reason }}<br />
    Supplier Number: {{ audit.supplier_number }}<br />
    Used catalouge: <b>VDA 6.3</b>
    <br />
    <br />
    <b-row>
        <b-col cols=3 class="col-maxwidth">
            <h4>Process Steps <b-btn v-b-modal.new_process variant="primary">+</b-btn></h4>
            <div v-for="step in audit.process_steps">
                <b-card class="process_step_card">
                    <strong>#{{ step.step_number }}</strong> - {{ step.description }}
                </b-card>
            </div>
        </b-col>
        <b-col cols=1></b-col>
        <b-col>
            <h4>Audit</h4>
            <router-link :to="'/audit/' + audit.audit_id + '/perform'" class="btn btn-primary">Perform</router-link>
        </b-col>
    </b-row>

    <b-modal ref="modalRef" @ok="ok_method" @shown="clear_modal" no-fade id="new_process" size="lg" title="Add process step">
        <NewProcessstep :form=form :submit_handler=handle_submit />
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import NewProcessstep from '@/components/NewProcessstep.vue';

export default {
  data () {
    return {
        form: {
            'step_number': '',
            'description': ''
        },
        process_steps: []
    }
  },
  props: ['audit'],
  created () {
      
  },
  watch: {
      
  },
  methods: {
      ok_method (evt) {
          evt.preventDefault();
          this.handle_submit();
      },
      handle_submit() {
          this.$http.post('v1/audits/' + this.audit.audit_id + '/process_steps/', {
              step_number: this.form.step_number,
              description: this.form.description
          }).then(response => {
              this.audit.process_steps.push(response.data.response);
          })
          this.$refs.modalRef.hide();
      },
      clear_modal() {
          this.form.step_number = '';
          this.form.description = '';
      }
  },
  components: {
      NewProcessstep
  }
}
</script>
<style>
.process_step_card {
    margin-bottom: 10px;
}
.col-maxwidth {
    max-width: 300px;
}
</style>